<template>
    <div class="text-expander" :class="{ freezeOpen: freezeOpen }">
        <a v-if="!freezeOpen" class="text-expander__toggle" @click="handleContentVisibility">
            <span>
                {{ label }}
            </span>
            <svg-icon class="text-expander__icon" :name="arrowIconType" />
        </a>
        <div v-show="showContent" class="text-expander__content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showLabel: {
            type: String,
            default: '',
        },
        hideLabel: {
            type: String,
            default: null,
        },
        /**
         * Mode that keeps the expander open and removes the toggle.
         * Useful for dynamic layouts which require expanders in certain scenarios and static blocks of content in another.
         */
        freezeOpen: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showContent: false,
        };
    },
    computed: {
        arrowIconType() {
            return this.showContent ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
        },
        label() {
            if (this.hideLabel && this.showContent) {
                return this.hideLabel;
            }

            return this.showLabel;
        },
    },
    watch: {
        freezeOpen() {
            /**
             * Prop 'freezeOpen' was changed in the parent component.
             * Makes sure that content is hidden again if freezeOpen is false.
             */
            this.showContent = this.freezeOpen;
        },
    },
    created() {
        if (this.freezeOpen) {
            this.showContent = true;
        }
    },
    methods: {
        handleContentVisibility() {
            if (this.freezeOpen) {
                return;
            }

            this.showContent = !this.showContent;
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.text-expander {
    margin-bottom: 1.5em;

    &__toggle {
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        font-weight: 600;
        color: $primary-lightest;
    }

    &__icon.svg-icon {
        height: 24px;
        width: 24px;
        flex-shrink: 0;
    }

    &__content {
        text-align: left;
        margin-top: 10px;

        @include md {
            margin-top: 20px;
        }
    }

    &.freezeOpen {
        &__toggle {
            cursor: initial;
        }
    }
}
</style>
